var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrowserCursorClick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4.494 11.998h27.012M16.298 8.239l-.007.007.007.008.008-.008z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m30.935 25.412-6.702-2.234a.833.833 0 0 0-1.055 1.055l2.234 6.702a.834.834 0 0 0 1.506.166l1.354-2.257c.14-.235.337-.431.572-.572l2.257-1.354a.834.834 0 0 0-.166-1.506",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m31.078 31.078-2.555-2.555M28.576 18.572l-.811.834zM23.574 16.5l.015 1.163M18.572 18.572l.834.81zM16.5 23.573l1.164-.016zM18.572 28.576l.834-.811zM12.488 8.239l-.007.007.007.008.008-.008zM8.665 8.231l-.008.007.008.008.007-.008z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.999 31.506H7.496a3 3 0 0 1-3.002-3.002V7.496a3 3 0 0 1 3.002-3.002h21.008a3 3 0 0 1 3.002 3.002v7.503"
})));
export default SvgBrowserCursorClick;